import { useTheme } from '@mui/material';

export const IntroIcon1 = ({ className }: { className: string }) => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
    } = theme.colors.other.icon;

    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="27"
            viewBox="0 0 24 27"
            fill="none"
        >
            <path
                d="M2.85002 6.97073L12 3.0694L21.15 6.97073C21.445 7.09642 21.605 7.36288 21.6 7.61425C21.58 12.2094 19.68 20.1478 12.285 23.7073C12.105 23.7927 11.895 23.7927 11.72 23.7073C4.32001 20.1428 2.42502 12.2094 2.40002 7.60923C2.40002 7.35785 2.55502 7.09642 2.85002 6.96571V6.97073ZM22.085 4.74858L12.67 0.731613C12.46 0.63609 12.235 0.585815 12 0.585815C11.765 0.585815 11.54 0.63609 11.33 0.731613L1.91502 4.74858C0.815021 5.21614 -0.00497725 6.3071 2.27424e-05 7.62431C0.0250227 12.6116 2.06502 21.7365 10.68 25.8842C11.515 26.2864 12.485 26.2864 13.32 25.8842C21.94 21.7365 23.975 12.6116 24 7.62431C24.005 6.3071 23.185 5.21614 22.085 4.74858ZM17.65 11.0933C18.12 10.6207 18.12 9.85652 17.65 9.38896C17.18 8.9214 16.42 8.91637 15.955 9.38896L10.405 14.9695L8.05501 12.6066C7.58501 12.134 6.82501 12.134 6.36001 12.6066C5.89501 13.0791 5.89001 13.8433 6.36001 14.3109L9.56 17.5285C10.03 18.0011 10.79 18.0011 11.255 17.5285L17.65 11.0933Z"
                fill={primaryStroke}
            />
        </svg>
    );
};
